export const GAP_UNIT_SIZE = 4 as const;
